import Accordion, { AccordionItem } from '@ingka/accordion';
import Button from '@ingka/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, Sheets } from '@ingka/modal';
import { translate } from '@repo/phrase';

import { DaysFilter } from '@/components/filters/days-filter';
import { useSearch } from '@/components/filters/search/search.hooks';
import { TypeFilter } from '@/components/filters/type-filter';

interface Props {
    visible: boolean;
    toggleVisible: () => void;
}

export const AllFiltersModal = ({ visible, toggleVisible }: Props) => {
    const { removeAllFilters, assetIdFilter, hasFilter } = useSearch();
    const daysFilterLabel = assetIdFilter ? 'filter_no_days' : 'filter_days';

    const clearAll = () => {
        removeAllFilters();
        toggleVisible();
    };

    return (
        <Modal handleCloseBtn={toggleVisible} visible={visible} data-testid="all-filters-modal">
            <Sheets
                aria-label={translate('filter_all')}
                header={<ModalHeader title={translate('filter_all')} />}
                footer={
                    <ModalFooter>
                        <Button text={translate('filter_clear_all')} onClick={clearAll} disabled={!hasFilter} />
                    </ModalFooter>
                }
            >
                <ModalBody>
                    <Accordion>
                        <AccordionItem
                            id="order-taking-accordion-days"
                            title={translate(daysFilterLabel)}
                            disabled={Boolean(assetIdFilter)}
                        >
                            <DaysFilter />
                        </AccordionItem>
                        <AccordionItem id="order-taking-accordion-type" title={translate('filter_type')}>
                            <TypeFilter />
                        </AccordionItem>
                    </Accordion>
                </ModalBody>
            </Sheets>
        </Modal>
    );
};
